import { getKeyName } from '../QueriedContent/DetailGene';
import { formatGtpList, formatMaxTcesGtp, parseGtpItems } from '@/utils/formatGtpList';
import { isRelease263Enabled } from '@/config/release263Features';
import { dispatchOpenGtpRowDetailForGene } from '@/utils/openGtpRowDetail';
import { getRowGeneNcbiId } from '@/utils/geneNcbiId';

const formatNumberAttributes = attribute => {
  return typeof attribute === 'number' ? attribute.toFixed(2) : '';
};

function uniqueProteinClass(proteins) {
  const proteinClassArray = [];
  proteins.map(protein => {
    protein.proteinClasses.map(proteinClass => {
      if (!proteinClassArray.includes(proteinClass.name)) {
        proteinClassArray.push(proteinClass.name);
      }
    });
  });

  return proteinClassArray.join(' ');
}

export default function GeneGeneralInfo({ geneDetailInfo, linkMaxTcesGtp = false }) {
  const { symbol, proteinIDs, proteins, gene_ensembl_id, description, DPI, DSI, PLI } = geneDetailInfo;
  const entrezId = getRowGeneNcbiId(geneDetailInfo) ?? '-';
  const gtpValue = geneDetailInfo?.GTP ?? geneDetailInfo?.gtp ?? geneDetailInfo?.GTAP ?? geneDetailInfo?.gtap;
  const formattedGtp = formatGtpList(gtpValue);
  const maxTcesGtpLabel = formatMaxTcesGtp(parseGtpItems(gtpValue));

  const geneLink = `http://www.ncbi.nlm.nih.gov/gene/${entrezId}`;
  const formattedDPI = formatNumberAttributes(DPI);
  const formattedDSI = formatNumberAttributes(DSI);
  const formattedPLI = formatNumberAttributes(PLI);

  return (
    <div className="table-container">
      <table className="table">
        <tbody>
          <tr>
            <td className="text-left">
              <strong>Entrez Id:</strong>
            </td>
            <td>{entrezId}</td>
          </tr>

          <tr>
            <td className="text-left">
              <strong>Gene Symbol:</strong>
            </td>
            <td>
              <a href={geneLink} className="mapId" target="_blank" rel="noreferrer">
                {symbol} <i className="fa fa-external-link" aria-hidden="true"></i>
              </a>
            </td>
          </tr>

          <tr>
            <td className="text-left">
              <strong>Uniprot accession:</strong>
            </td>
            <td>
              {proteinIDs.map(protein => {
                const linkProtein = `https://www.uniprot.org/uniprot/${protein}`;
                return (
                  <span key={getKeyName(protein)}>
                    <a href={linkProtein} className="mapId" target="_blank" rel="noreferrer">
                      {'  '}
                      {protein} <i className="fa fa-external-link" aria-hidden="true"></i>
                    </a>
                    {'  '}
                  </span>
                );
              })}
            </td>
          </tr>

          <tr>
            <td className="text-left">
              <strong>Ensembl Gene:</strong>
            </td>
            <td>
              {gene_ensembl_id.map(ensemblId => {
                return <span key={getKeyName(ensemblId)}> {ensemblId}</span>;
              })}
            </td>
          </tr>

          <tr>
            <td className="text-left">
              <strong>Full name:</strong>
            </td>
            <td>{description}</td>
          </tr>

          <tr>
            <td className="text-left">
              <strong>Protein class:</strong>
            </td>
            <td>{uniqueProteinClass(proteins)}</td>
          </tr>

          <tr>
            <td className="text-left">
              <strong>DPI:</strong>
            </td>
            <td>{formattedDPI}</td>
          </tr>

          <tr>
            <td className="text-left">
              <strong>DSI:</strong>
            </td>
            <td>{formattedDSI}</td>
          </tr>

          <tr>
            <td className="text-left">
              <strong>pLi:</strong>
            </td>
            <td>{formattedPLI}</td>
          </tr>

          {isRelease263Enabled && formattedGtp !== '-' ? (
            <tr>
              <td className="text-left">
                <strong>GTAP:</strong>
              </td>
              <td>
                {linkMaxTcesGtp && maxTcesGtpLabel !== '-' ? (
                  <button
                    type="button"
                    className="tab-links inline max-w-full whitespace-normal break-words border-0 bg-transparent p-0 text-left"
                    aria-label="View GTAP profile"
                    title={maxTcesGtpLabel}
                    onClick={() => dispatchOpenGtpRowDetailForGene(geneDetailInfo)}
                  >
                    {maxTcesGtpLabel}
                  </button>
                ) : (
                  formattedGtp
                )}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}
